import { Routes } from '@angular/router';
import { LeiComponent } from './app/lei/lei.component';
import {HomeComponent} from "./app/home/home.component";

export const appRoutes: Routes = [
  { path: 'home' , component: HomeComponent },
  { path: 'lei' , component: LeiComponent },
  { path: '', redirectTo: '/home' , pathMatch: 'full'}
]
